import { render, staticRenderFns } from "./IdeaDetail.vue?vue&type=template&id=f1535d68&"
import script from "./IdeaDetail.vue?vue&type=script&lang=js&"
export * from "./IdeaDetail.vue?vue&type=script&lang=js&"
import style0 from "./IdeaDetail.vue?vue&type=style&index=0&id=f1535d68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports